import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSwiperComponent } from './simple-icons-swiper.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSwiperComponent ],
    exports:      [ SimpleIconsSwiperComponent ],
    bootstrap:    []
})
export class SimpleIconsSwiperModule {}
